// tslint:disable: max-line-length
import { CustomItem, FindParamsItems } from '@domains';
import { Action, createReducer, on } from '@ngrx/store';

import * as fromActions from './item.actions';

export interface ItemState {
  items: Array<CustomItem>;
  itemsTotalCount: number;
  item: CustomItem;
  findParams: { [key: string]: FindParamsItems };
}

const initialState: ItemState = {
  items: new Array<CustomItem>(),
  itemsTotalCount: 0,
  item: undefined,
  findParams: JSON.parse(localStorage.getItem('ItemFindParams') || '{}'),
};

const reducer = createReducer(
  initialState,

  on(fromActions.getItems, (state, { findParams, keep }) => {
    const newValue = { ...state.findParams };
    newValue[window.location.pathname] = findParams;
    return { ...state, itemsTotalCount: keep ? state.itemsTotalCount : 0, items: keep ? state.items : [], findParams: newValue };
  }),
  on(fromActions.getItemsSuccess, (state, { resultsCount, results }) => ({
    ...state,
    itemsTotalCount: resultsCount,
    items: results,
  })),
  on(fromActions.clearItems, (state) => ({
    ...state,
    itemsTotalCount: 0,
    items: new Array<CustomItem>(),
  })),
  on(fromActions.clearItemsFindParams, (state) => {
    const newValue = { ...state.findParams };
    newValue[window.location.pathname] = {};
    return { ...state, findParams: newValue };
  }),

  on(fromActions.getItem, (state) => ({ ...state, item: null })),
  on(fromActions.getItemSuccess, (state, action: any) => ({ ...state, item: new CustomItem(action.item) })),
);
export function itemReducer(state: ItemState | undefined, action: Action) {
  return reducer(state, action);
}
